var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('p',[_vm._v(_vm._s(_vm.statusMessage))]),(_vm.showModal)?_c('AlertModal',{attrs:{"message":_vm.modalMessage},on:{"close":_vm.handleModalClose}}):_vm._e(),(_vm.isLoading)?_c('div',{staticClass:"spinner-loading"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }